import Navbar from "@/components/sections/Navbar";
import HeroSection from "@/components/sections/HeroSection";
import ServicesSection from "@/components/sections/ServicesSection";
import PlatformsSection from "@/components/sections/PlatformsSection";
import AppDevSection from "@/components/sections/AppDevSection";
import MediaSocialSection from "@/components/sections/MediaSocialSection";
import ImageCarousel from "@/components/sections/ImageCarousel";
import PatentsSection from "@/components/sections/PatentsSection";
import StatsAboutSection from "@/components/sections/StatsAboutSection";
import GalleryPricingSection from "@/components/sections/GalleryPricingSection";
import SanMarinoMarketBanner from "@/components/sections/SanMarinoMarketBanner";
import BlogTestimonialsSection from "@/components/sections/BlogTestimonialsSection";
import ContactFooter from "@/components/sections/ContactFooter";
import LiveChat from "@/components/sections/LiveChat";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#050505] min-h-screen overflow-x-hidden">
      <Navbar />
      {/* 1. Hero - prima impressione */}
      <HeroSection />
      {/* 2. Servizi - cosa facciamo (subito dopo hero) */}
      <ServicesSection />
      {/* 3. Piattaforme - i nostri prodotti */}
      <PlatformsSection />
      {/* 4. Stats & Chi Siamo - credibilita */}
      <StatsAboutSection />
      {/* 5. Sviluppo App */}
      <AppDevSection />
      {/* 6. Social Media TV/Cinema */}
      <MediaSocialSection />
      {/* 7. Carosello immagini lavori */}
      <ImageCarousel />
      {/* 8. Brevetti */}
      <PatentsSection />
      {/* 9. Prezzi */}
      <GalleryPricingSection />
      {/* 10. San Marino Market */}
      <SanMarinoMarketBanner />
      {/* 11. Blog & Testimonianze */}
      <BlogTestimonialsSection />
      {/* 12. Contatti & Footer */}
      <ContactFooter />
      <LiveChat />
    </div>
  );
}
